import { render, staticRenderFns } from "./myActivityList.vue?vue&type=template&id=b5c74040&scoped=true"
import script from "./myActivityList.vue?vue&type=script&lang=js"
export * from "./myActivityList.vue?vue&type=script&lang=js"
import style0 from "./myActivityList.vue?vue&type=style&index=0&id=b5c74040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c74040",
  null
  
)

export default component.exports